import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Message = styled('div')`
  font-weight: 400;
  font-size: 14px;
  line-height: 125%;
  color: ${theme.palette.secondary.main};
  margin-bottom: 24px;
`;

export const Errors = styled('div')`
  color: ${theme.palette.error.main};
  font-size: 12px;
  padding: 4px 12px;
`;

export const Actions = styled('div')`
  margin-top: 24px;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
`;
